import React, { SyntheticEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";

import {
  Box,
  Button,
  FormControl,
  IconButton,
  Menu,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { GridColDef } from "@mui/x-data-grid";
import NewCompaniesList from "../../features/companies/newCompaniesList";
import ApprovedCompaniesList from "../../features/companies/approvedCompaniesList";
import RejectedCompaniesList from "../../features/companies/rejectedCompaniesList";
import { APPROVAL_STATUS, UPDATE_TYPES, USER_ROLES } from "../../utils/enums";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { isValidInput } from "../../utils/validations";
import {
  useChangeUserStatusMutation,
  useCompanyListMutation,
  useExportCsvMutation,
  useLazyCompanyCountQuery,
  useLazyDeleteUserQuery,
  useUserApprovalMutation,
} from "../../service/users";
import { CommonBody, CompanyList, Permission } from "../../types/General";
import { errorToast, successToast } from "../../helpers";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import useAuth from "../../hooks/useAuth";
import moment from "moment";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Companies = () => {
  const navigate = useNavigate();
  const userData = useAuth();
  const [hidePermission, setHidePermission] = useState<Permission>();

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [valueTabs, setValueTabs] = useState(APPROVAL_STATUS.PENDING);
  const [newUsers, setNewUsers] = useState<number>(0);
  const [approvedUsers, setApprovedUsers] = useState<number>(0);
  const [rejectedUsers, setRejectedUsers] = useState<number>(0);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [exportCsv] = useExportCsvMutation();

  const [companiesList] = useCompanyListMutation();
  const [deleteUser] = useLazyDeleteUserQuery();
  const [changeStatus] = useChangeUserStatusMutation();
  const [userApproval] = useUserApprovalMutation();
  const [companyCount] = useLazyCompanyCountQuery();

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<CompanyList[]>([]);
  const [page, setPage] = useState<number>(1);

  // <--------EXPORT CSV DATE---------->
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // List of years (e.g., last 30 years)
  const years = Array.from({ length: 30 }, (_, i) => currentYear - i);

  // List of months, filtered if current year
  const allMonths = moment.months().map((label, index) => ({
    label,
    value: index + 1,
  }));

  const filteredMonths = allMonths.filter((m) => {
    if (parseInt(year) === currentYear) {
      return m.value <= currentMonth;
    }
    return true;
  });

  const getMinDate = () => {
    return moment(`${year}-01-01`).format("YYYY-MM-DD");
  };

  const getMaxDate = () => {
    const today = moment();
    const selectedYear = parseInt(year);

    if (selectedYear === today.year()) {
      return today.format("YYYY-MM-DD");
    }
    return moment(`${year}-12-31`).format("YYYY-MM-DD");
  };

  useEffect(() => {
    if (year && month) {
      const start = moment(`${year}-${String(month).padStart(2, "0")}-01`);
      const today = moment();
      const isCurrentMonth =
        start.isSame(today, "month") && start.isSame(today, "year");

      const end = isCurrentMonth ? today : moment(start).endOf("month");

      setFromDate(start.format("YYYY-MM-DD"));
      setToDate(end.format("YYYY-MM-DD"));
    }
  }, [year, month]);

  // <--------EXPORT CSV DATE---------->
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);

  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
  };
  const fetchCount = async () => {
    setLoading(true);
    try {
      const response = await companyCount().unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setNewUsers(response?.data?.new_companies || 0);
        setApprovedUsers(response?.data?.approved_companies || 0);
        setRejectedUsers(response?.data?.rejected_companies || 0);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 300,
      field: "name",
      headerName: "B2B Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              <b>{row?.company_name}</b> {row?.company_country_code}{" "}
              {row?.company_phone_no || "-"} <br />
              {row?.company_email || "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: "storeName",
      headerName: "Representative Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure onClick={() => navigate(`/users/company/${row?.id}`)}>
              <img
                src={
                  row?.profile_picture?.media_url ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>
                {row?.first_name} {row?.middle_name || ""}{" "}
                {row?.last_name || ""}
              </b>{" "}
              {row?.country_code} {row?.phone_no || "-"} <br />
              {row?.email || "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "representativeRole",
      headerName: "Representative Designation",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.designation || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "licenseNo",
      headerName: "Trade License No.",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.trade_license_number || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "brn",
      headerName: "BRN.",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.business_registration_number || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: "address",
      headerName: "Complete Address",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.address || "-"}</p>
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row?.id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_add_edit ? (
                  <MenuItem
                    onClick={() => {
                      if (selectedId) {
                        setModalType("accept");
                        setAnchorEl1(null);
                        setOpen(true);
                      }
                    }}
                  >
                    Approve
                  </MenuItem>
                ) : null}
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_add_edit ? (
                  <MenuItem
                    onClick={() => {
                      if (selectedId) {
                        setAnchorEl1(null);
                        setModalType("reject");
                        setOpen(true);
                      }
                    }}
                  >
                    Reject
                  </MenuItem>
                ) : null}
                <MenuItem
                  onClick={() => navigate(`/users/company/${selectedId}`)}
                >
                  View
                </MenuItem>
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_add_edit ? (
                  <MenuItem
                    onClick={() =>
                      navigate(`/users/company/edit/${selectedId}`)
                    }
                  >
                    Edit
                  </MenuItem>
                ) : null}
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];
  const handleDeleteUser = async () => {
    setLoading(true);
    try {
      const response = await deleteUser({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        successToast("Deleted successfully");
        getUsersList();
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleUserUpdate = async (id: number, status: any, type: string) => {
    const body = {
      ...(type === UPDATE_TYPES.BLOCK ? { is_active: status } : {}),
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await changeStatus({
        body: encryptedBody,
        id: id,
      }).unwrap();
      if (response?.status === 200) {
        const updatedData = rows?.map((item) => {
          if (item?.id === id) {
            return {
              ...item,
              is_active: status,
            };
          }
          return item;
        });
        setRows(updatedData);
        if (status === true) {
          successToast("Status enabled successfully");
        } else {
          successToast("Status disabled successfully");
        }
      } else {
        errorToast("Please try again");
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const getUsersList = async () => {
    setLoading(true);
    try {
      const body = {
        start: page,
        length: 10,
        search: debouncedSearchTerm.trim(),
        type: valueTabs + 1,
        ...(fromDate && toDate ? { from_date: fromDate, to_date: toDate } : {}),
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await companiesList(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
        setCount(response?.data?.total_records);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleApproveReject = async (reason: string | undefined) => {
    const body = {
      is_approved: modalType === "accept" ? true : false,
      reject_reason: reason || "",
    };
    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await userApproval({
        body: encryptedBody,
        id: selectedId,
      }).unwrap();
      if (response?.status === 200) {
        successToast(
          modalType === "accept"
            ? "B2B approved successfully"
            : "B2B rejected successfully"
        );
        if (modalType === "accept") {
          setValueTabs(APPROVAL_STATUS.APPROVED);
          setPage(1);
        } else {
          setValueTabs(APPROVAL_STATUS.REJECTED);
          setPage(1);
        }
      } else {
        errorToast("Please try again");
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const handleExportCSV = async () => {
    setLoading(true);
    try {
      const body = {
        role: USER_ROLES.COMPANY,
        status: valueTabs + 1,
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await exportCsv(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        window.open(response?.file_urls);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsersList();
    fetchCount();
  }, [debouncedSearchTerm, page, valueTabs, fromDate, toDate]);

  const checkPermission = () => {
    const permission = userData?.role_permission;
    if (permission?.length) {
      const foundPermission = permission?.find(
        (ele: Permission) => ele?.module === "Users"
      );

      if (foundPermission) {
        setHidePermission(foundPermission);
      } else {
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    if (userData?.user_role_type === USER_ROLES.SUBADMIN) {
      checkPermission();
    }
  }, [userData]);

  useEffect(() => {
    if (typeof hidePermission !== "undefined") {
      if (!hidePermission?.can_view) {
        navigate("/permission-denied", { replace: true });
      }
    }
  }, [hidePermission, userData]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>B2B</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Users
          - B2B
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box
                display="flex"
                gap={1.5}
                flexWrap="nowrap"
                alignItems="center"
              >
                <FormControl
                  size="small"
                  className="btn btn_highlight"
                  sx={{ minWidth: 100 }}
                >
                  <Select
                    // labelId="year-label"
                    value={year}
                    onChange={(e) => {
                      setYear(e.target.value);
                      setMonth("");
                      setFromDate("");
                      setToDate("");
                    }}
                    // label="Year"
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Year
                    </MenuItem>
                    {years.map((y) => (
                      <MenuItem key={y} value={y.toString()}>
                        {y}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {year && (
                  <FormControl
                    size="small"
                    className="btn btn_highlight"
                    sx={{ minWidth: 120 }}
                  >
                    {/* <InputLabel id="month-label">Month</InputLabel> */}
                    <Select
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select Month
                      </MenuItem>
                      {filteredMonths.map((m) => (
                        <MenuItem key={m.value} value={m.value}>
                          {m.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {year && month && (
                  <>
                    <TextField
                      type="date"
                      fullWidth
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      inputProps={{
                        min: getMinDate(),
                        max: getMaxDate(),
                      }}
                    />

                    <TextField
                      type="date"
                      fullWidth
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      inputProps={{
                        min: fromDate || getMinDate(),
                        max: getMaxDate(),
                      }}
                    />
                  </>
                )}
              </Box>
              <Box>
                <Button className="btn btn_highlight" onClick={handleExportCSV}>
                  <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
                  CSV
                </Button>
              </Box>
            </div>
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab
              label={`New B2B (${newUsers})`}
              {...a11yProps(APPROVAL_STATUS.PENDING)}
            />
            <Tab
              label={`Approved B2B (${approvedUsers})`}
              {...a11yProps(APPROVAL_STATUS.APPROVED)}
            />
            <Tab
              label={`Rejected B2B (${rejectedUsers})`}
              {...a11yProps(APPROVAL_STATUS.REJECTED)}
            />
          </Tabs>

          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.PENDING}>
            <NewCompaniesList
              rows={rows}
              columns={columns}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.APPROVED}>
            <ApprovedCompaniesList
              count={count}
              rows={rows}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
              setUsers={setRows}
              setSelectedId={setSelectedId}
              handleDeleteUser={handleDeleteUser}
              handleUserUpdate={handleUserUpdate}
              setModalType={setModalType}
              setOpen={setOpen}
              selectedId={selectedId}
              hidePermission={hidePermission}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.REJECTED}>
            <RejectedCompaniesList
              count={count}
              rows={rows}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
              setSelectedId={setSelectedId}
              selectedId={selectedId}
              setOpen={setOpen}
              setModalType={setModalType}
              hidePermission={hidePermission}
            />
          </CustomTabPanel>
        </Box>
        <ConfirmationModal
          text={
            modalType === "delete"
              ? "Are you sure to delete this B2B?"
              : modalType === "accept"
                ? "Are you sure to approve this B2B?"
                : modalType === "reject"
                  ? "Are you sure to reject this B2B?"
                  : ""
          }
          reject={modalType === "reject" ? true : false}
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={
            modalType === "delete"
              ? handleDeleteUser
              : modalType === "accept" || modalType === "reject"
                ? (reason) => handleApproveReject(reason)
                : () => {}
          }
        />
      </div>
    </MainContainer>
  );
};

export default Companies;
